import { CallState, LoadingState } from '@lcs/shared/api';
import { Action, createReducer, on } from '@ngrx/store';
import { onReset } from 'src/app/authentication/reset-reducer';
import * as AddRoleActions from './add-role.actions';

export const addRoleFeatureKey = 'addRole';

export interface AddRoleState {
   callState: CallState;
}

export const initialState: AddRoleState = {
   callState: LoadingState.Init,
};

const addRoleReducer = createReducer(
   initialState,
   onReset(initialState),
   on(AddRoleActions.createRole, (state) => {
      return {
         ...state,
         callState: LoadingState.Loading,
      };
   }),
   on(AddRoleActions.createRoleSuccess, (state) => {
      return {
         ...state,
         callState: LoadingState.Loaded,
      };
   }),
   on(AddRoleActions.createRoleFailure, (state) => {
      return {
         ...state,
         callState: LoadingState.Loaded,
      };
   })
);

export function reducer(state: AddRoleState | undefined, action: Action) {
   return addRoleReducer(state, action);
}
